<template>
    <div class="modal-card card">
        <form @submit.prevent="onAddEntitlement()">
        <div class="card-header">
            <div class="catalog-modal-head">
                <span class="catalog-identity-icon"><i class="fa fa-gauge-high"></i></span>
                <div>
                    <h4 class="card-header-title">Add Entitlement</h4>
                    <p class="catalog-card-subtitle">Version is optional and defaults to 1.</p>
                </div>
            </div>
            <!-- Close -->
            <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
            ></button>
        </div>
        <div class="card-body">
                <div v-for="section in fieldSections" :key="section.key" class="catalog-modal-section">
                    <span class="catalog-label">{{ section.title }}</span>
                    <form-fields :fields="section.fields" v-model="entitlement" />
                </div>
                <div v-if="error" class="text-danger">
                    {{error}}
                </div>
        </div>
        <div class="card-footer">
            <div class="d-flex justify-content-end gap-2">
                <button type="button" class="btn btn-white" data-bs-dismiss="modal">Cancel</button>
                <submit-button :fields="fields" v-model="entitlement" />
            </div>
        </div>
        </form>
    </div>
</template>

<script>
import formFields from '../FormFields.vue';
import submitButton from '../SubmitButton.vue'
import {mapActions} from 'vuex';
import Fields from "../../utils/field-constants/entitlementFields";
const FIELD_SECTIONS = [
    { key: "definition", title: "Definition", names: ["name", "version", "metrics_key", "unit", "description"] },
    { key: "metering", title: "Metering", names: ["quantity", "aggregation", "multiple_allowed"] },
    { key: "base", title: "Base entitlement (optional)", names: ["base_entitlement_id", "base_qty_consumed", "conversion_floor", "qty_included_w_base"] }
];
export default {
    components: { formFields, submitButton },
    data(){
        return {
            error: "",
            entitlement: {base_entitlement_id:0},
            fields: []
        }
    },
    name: "AddEntitlement",
    mounted(){
        this.fields= JSON.parse(JSON.stringify(Fields));
        //setting base entitlement options as entitlement name and id
        this.fields.forEach((field)=>{
            if(field.name=="base_entitlement_id"){
                field.options=this.entitlementList.map((item)=>{
                    return { label: item.name, value: item.entitlement_id }
                })
            }
        })
        //hiding
        this.fields.map((field)=>{
            if(field.name ==="created_by" || field.name ==="created_at" ||
                field.name ==="updated_by" || field.name ==="updated_at"){
                    field.visible= false
                }
        })
    },
    computed:{
        entitlementList(){
            return this.$store.state.admin.entitlements
        },
        fieldSections() {
            const grouped = FIELD_SECTIONS.flatMap((section) => section.names);
            return FIELD_SECTIONS.map((section) => ({
                ...section,
                fields: this.fields.filter((field) => section.names.includes(field.name) ||
                    (section.key === "definition" && !grouped.includes(field.name)))
            }));
        }
    },
    methods: {
        ...mapActions('admin', {
            createEntitlement: 'createEntitlement'
        }),
        async onAddEntitlement() {
            let valid = true;
            let toastoptions;
            try {
                valid = !this.entitlementList.some((item) => item.name === this.entitlement.name && item.version === (this.entitlement.version || 1))
                if( valid ){
                    await this.createEntitlement(this.entitlement);
                    toastoptions = {
                        message: "Entitlement '"+this.entitlement.name+"' added successfully.",
                        type: "success",
                    };
                }else{
                    toastoptions = {
                            message: "Already '"+this.entitlement.name+"' version "+(this.entitlement.version || 1)+" exists.",
                            type: "error",
                        };
                }
            } catch (error) {
                if (error.response.data.error) 
                    this.error = error.response.data.error
                else 
                    this.error = error.message
                
                return
            }
            this.$store.dispatch('addToast', toastoptions);
            if(valid){
                this.$store.dispatch('hideModal');
                this.$store.dispatch('admin/fetchEntitlements');
            }
        }
    }
};
</script>

<style>
</style>